"use client"
import React, { useState, useEffect, useRef } from 'react';

import { connect } from "react-redux";
import DataTableListGenerica from './DataTableListGenerica/DataTableListGenerica'
import FormularioGenerico from './DataTableGenerica/FormularioGenerico';
//import DataTableGenerica from './DataTableGenerica'
import DataTableGenerica from './DataTableGenerica/DataTableGenerica'


import PrimeReact from "primereact/api";

import { Skeleton } from 'primereact/skeleton';
import { Inplace, InplaceDisplay, InplaceContent } from 'primereact/inplace';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import classNames from 'classnames';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Divider } from 'primereact/divider';
import { getConfigSubdomainDefault, GetCurrentUserDefault } from '../storage/getConfigSubdomainDefault';

import { ContenidoPublico } from '../templates/ContenidoPublico';

import { GenericaSistemaService } from '../service/GenericaSistemaService';
import { PlantillaService } from '../service/PlantillaService';

import AuthStorage from '../storage/AuthStorage';
import AuthController from '../controller/AuthController';

import { InputTextarea } from 'primereact/inputtextarea';
import { Editor } from 'primereact/editor';
import Link from 'next/link';

import Document from './DataTableGenerica/Document';

import lodash from "lodash";
import crypto from "crypto-js";

import "primereact/resources/primereact.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "prismjs/themes/prism-coy.css";
import "../assets/demo/flags/flags.css";
import "../assets/demo/Demos.scss";
import "../assets/layout/layout.scss";
import "../App.scss";

import "../assets/css/BlocksPublicURLShared.css";
//import { select } from 'jodit/esm/plugins/select/select';


const BlocksPublicURLShared = (props) => {

    console.log("BlocksPublicURLShared")

    const authController = new AuthController();
    const [authStorage, setAuthStorage] = useState(undefined);

    const [dataConfigSubdomain, setDataConfigSubdomain] = useState(getConfigSubdomainDefault);
    let { subdomain, idSuscripcion, idEmpresaInit, idiomaInit } = dataConfigSubdomain;



    const userDetails = authStorage ? authStorage.GetCurrentUser() : GetCurrentUserDefault();
    let { userName, idEmpresa, idioma, sessionGUID, documentoInvitado } = userDetails;

    const [queryParams, setQueryParams] = useState(undefined);


    const genericaSistemaService = new GenericaSistemaService();

    //const urlFullLogoLoginDefault = "assets/layout/images/logo-login.png";

    //let urlFullLogoLogin = urlLogoLogin ? process.env.NEXT_PUBLIC_URL_API + urlLogoLogin : urlFullLogoLoginDefault;

    //const { user: ContextState, configSubdomain, login } = useContext(AuthProvider);
    //const {isLoginPending,isLoggedIn,loginError, subdomain, userName, idSuscripcion, idEmpresa, idioma } = ContextState;

    //const authService = new AuthService();
    const plantillaService = new PlantillaService();

    const codMenu = "LOGIN";

    const [etiquetasMenu, setEtiquetasMenu] = useState([]);
    const [intentoErrado, setIntentoErrado] = useState(0);

    const [tokenErrado, setTokenErrado] = useState(undefined);

    const [vecesBotonPresionado, setVecesBotonPresionado] = useState(0);

    const [etiquetasModulo, setEtiquetasModulo] = useState([]);

    const [payLoad, setPayLoad] = useState(null);

    const [dialogTextVisible, setDialogTextVisible] = useState(true);

    const [locationPath, setLocationPath] = useState("");

    const [usernameDiligenciador, setUsernameDiligenciador] = useState(undefined);

    const dataTableGenericaRef = useRef(null);


    //const payLoadRef = useRef(null);

    //const selectedTipoGenericaRef = { tg: "BAS_TERCERO", version: 0, filtroUts: { 'documentoTercero': '__' } };

    const [checked, setChecked] = useState(false);
    const [formDefault, setFormDefault] = useState({
        idSuscripcion: idSuscripcion,
        idioma: idiomaInit,
        idEmpresa: idEmpresaInit,
        subdomain: subdomain,
        userName: 'visit',
        password: ''
    });

    const [formLogin, setFormLogin] = useState({
        idSuscripcion: idSuscripcion,
        idioma: idiomaInit,
        idEmpresa: idEmpresaInit,
        subdomain: subdomain,
        userName: 'visit',
        password: ''
    });

    const [formAsVisit, setFormAsVisit] = useState({
        idSuscripcion: idSuscripcion,
        idioma: idiomaInit,
        idEmpresa: idEmpresaInit,
        subdomain: subdomain,
        userName: 'visit',
        password: ''
    });

    const loadDatosBase = async () => {
        await plantillaService.getEtiquetasMenuAuth(idEmpresaInit, idiomaInit, codMenu).then(data => {
            console.log("getEtiquetasMenuAuth, ", data);
            setEtiquetasMenu(data);
        });
    }

    function GetTextoEtiqueta(etiqueta) {
        return (etiquetasMenu.filter(et => et.etiqueta === etiqueta).map(et => et.ctiTexto));
    }


    useEffect(() => {

        console.log("useEffect_BlocksGuestUserURL, ");

        guidIntento.current = window.crypto.randomUUID();

        setLocationPath(window.location.pathname);

        const authStorage = new AuthStorage(window.location.pathname);
        let mewdataConfigSubdomain = authStorage.getConfigSubdomain();

        subdomain = mewdataConfigSubdomain.subdomain;
        idSuscripcion = mewdataConfigSubdomain.idSuscripcion;
        idEmpresaInit = mewdataConfigSubdomain.idEmpresaInit;
        idiomaInit = mewdataConfigSubdomain.idiomaInit;

        setAuthStorage(authStorage);
        setDataConfigSubdomain(mewdataConfigSubdomain);

        let newForm = {
            idSuscripcion: idSuscripcion,
            idioma: idiomaInit,
            idEmpresa: idEmpresaInit,
            subdomain: subdomain,
            userName: 'visit',
            password: ''
        };

        setFormAsVisit(newForm);
        setFormLogin(newForm);

        let response = authController.loginUser(newForm).then(response => {

            console.log("responseVisit, ", response);

            const userDetails = authStorage.GetCurrentUser();
            userName = userDetails.userName;
            idioma = userDetails.idioma;
            idEmpresa = userDetails.idEmpresa;
            sessionGUID = userDetails.sessionGUID
            documentoInvitado = userDetails.documentoInvitado


            loadDatosBase();

            const queryParams = new URLSearchParams(window.location.search);
            setQueryParams(queryParams);

            getPayloadRefQueryParam();

            if (response.userName !== undefined && response.userName !== "") {
                //setEtiquetasModulo([]);
            }

            if (response.userName !== undefined && response.userName !== "") {
                setEtiquetasModulo([]);
            }


        }

        ); //loginUser action makes the request and handles all the neccessary state changes

    }, []);



    const getPayloadRefQueryParam = async () => {

        //if (payLoadRef.current == null && window.location.search !== null) {
        if (payLoad == null && window.location.search !== null) {

            const queryParams = new URLSearchParams(window.location.search);

            let payloadQuery = queryParams.get("payload");
            let paramQuery = queryParams.get("Param");
            let jwtQuery = queryParams.get("t");
            let paramRol = queryParams.get("rol");

            let payloadDecoded = "";

            if (payloadQuery !== null && payloadQuery !== "") {

                payloadDecoded = payloadQuery;
                let payloadStr = Buffer.from(payloadDecoded, 'base64') + "";//.toString('ascii');

                const _payload = JSON.parse(payloadStr);
                console.log("payload, ", _payload);

                // Acá viene la particularidad de CECAR en el shortName del curso
                let newfiltroUts = _payload.bodyContentPayload.item.selectedTipoGenerica.filtroUts;

                /*
                let splitGrupo = newfiltroUts['codInternoCursoMoodle'].toString().split('_');
                let grupo = splitGrupo[0];  //se supone que es el primero

                if (splitGrupo.length === 0) {
                    grupo = "45326";
                }

                newfiltroUts['grupo'] = grupo;

                //delete newfiltroUts['codInternoCursoMoodle'];
                //console.log("newfiltroUts, ", newfiltroUts);

                
               
                let newTg = 'FMT_FORMATO-0'

                payload.bodyContentPayload.item.selectedTipoGenerica.tg = newTg

                payload.bodyContentPayload.item.selectedTipoGenerica.filtroUts = newfiltroUts;
                
                */


                //paypayload.bodyContentPayload.item.selectedTipoGenerica.filtroUts['codInternoMoodle'] = paypayload.bodyContentPayload.item.selectedTipoGenerica.filtroUts['codInternoMoodle'].split(',')[0];
                //paypayload.bodyContentPayload.item.selectedTipoGenerica.filtroUts['codMoodle']


                setPayLoad({ payloadDecoded: payloadDecoded, hash: _payload.hash, bodyContentPayload: _payload.bodyContentPayload });
                //payLoadRef.current = { payloadDecoded: payloadDecoded, hash: payload.hash, bodyContentPayload: payload.bodyContentPayload }


                //setSelectedTipoGenerica(undefined);
                //setComodin(prev => prev + 1);
            }
            else if (paramQuery !== null && paramQuery !== "") {

                let paramQueryDecrypted = "";
                paramQueryDecrypted = await genericaSistemaService.decryptString(idEmpresa, idioma, userName, paramQuery);
                paramQueryDecrypted = paramQueryDecrypted + '';

                let paramsQuery = paramQueryDecrypted.split("&");
                let payloadParam = paramsQuery[1].split("=")[1];  //esto es por la integración con Aldea

                //payloadDecoded = decodeURI(paramQueryDecrypted);

                let payloadStr = Buffer.from(payloadParam, 'base64') + "";//.toString('ascii');

                const _payload = JSON.parse(payloadStr);
                console.log("payload, ", _payload);

                // Acá viene la particularidad de CECAR en el shortName del curso
                let newfiltroUts = _payload.bodyContentPayload.item.selectedTipoGenerica.filtroUts;

                /*
                let splitGrupo = newfiltroUts['codInternoCursoMoodle'].toString().split('_');
                let grupo = splitGrupo[0];  //se supone que es el primero

                if (splitGrupo.length === 0) {
                    grupo = "45326";
                }

                newfiltroUts['grupo'] = grupo;

                //delete newfiltroUts['codInternoCursoMoodle'];
                //console.log("newfiltroUts, ", newfiltroUts);

                
               
                let newTg = 'FMT_FORMATO-0'

                payload.bodyContentPayload.item.selectedTipoGenerica.tg = newTg

                payload.bodyContentPayload.item.selectedTipoGenerica.filtroUts = newfiltroUts;
                
                */


                //paypayload.bodyContentPayload.item.selectedTipoGenerica.filtroUts['codInternoMoodle'] = paypayload.bodyContentPayload.item.selectedTipoGenerica.filtroUts['codInternoMoodle'].split(',')[0];
                //paypayload.bodyContentPayload.item.selectedTipoGenerica.filtroUts['codMoodle']



                setPayLoad({ payloadDecoded: payloadDecoded, hash: _payload.hash, bodyContentPayload: _payload.bodyContentPayload });
                //payLoadRef.current = { payloadDecoded: payloadDecoded, hash: payload.hash, bodyContentPayload: payload.bodyContentPayload }


                //setSelectedTipoGenerica(undefined);
                //setComodin(prev => prev + 1);
            }
            else if (jwtQuery !== null && jwtQuery !== "") {

                payloadDecoded = jwtQuery;
                let resultDataToken = "";
                resultDataToken = await genericaSistemaService.decodeToken(idEmpresa, idioma, userName, jwtQuery);


                let _payload = JSON.parse(resultDataToken);
                console.log("payload, ", _payload);

                if (_payload['error'] === undefined || _payload['error'] === "") {


                    // Acá viene la particularidad de CECAR en el shortName del curso
                    //let newfiltroUts = _payload.bodyContentPayload.item.selectedTipoGenerica.filtroUts;

                    /*
                    let splitGrupo = newfiltroUts['codInternoCursoMoodle'].toString().split('_');
                    let grupo = splitGrupo[0];  //se supone que es el primero
    
                    if (splitGrupo.length === 0) {
                        grupo = "45326";
                    }
    
                    newfiltroUts['grupo'] = grupo;
    
                    //delete newfiltroUts['codInternoCursoMoodle'];
                    //console.log("newfiltroUts, ", newfiltroUts);
    
                    
                   
                    let newTg = 'FMT_FORMATO-0'
    
                    payload.bodyContentPayload.item.selectedTipoGenerica.tg = newTg
    
                    payload.bodyContentPayload.item.selectedTipoGenerica.filtroUts = newfiltroUts;
                    
                    */


                    //paypayload.bodyContentPayload.item.selectedTipoGenerica.filtroUts['codInternoMoodle'] = paypayload.bodyContentPayload.item.selectedTipoGenerica.filtroUts['codInternoMoodle'].split(',')[0];
                    //paypayload.bodyContentPayload.item.selectedTipoGenerica.filtroUts['codMoodle']

                    //payLoad.bodyContentPayload.item.selectedTipoGenerica
                    _payload["selectedTipoGenerica"] = { tg: _payload["tg"], filtroUts: _payload['f'], ctiTextoFiltroUts: _payload['t'] };

                    _payload = { hash: "", bodyContentPayload: { item: { ..._payload } } }

                    setPayLoad({ payloadDecoded: payloadDecoded, hash: _payload.hash, bodyContentPayload: _payload.bodyContentPayload });
                    //payLoadRef.current = { payloadDecoded: payloadDecoded, hash: payload.hash, bodyContentPayload: payload.bodyContentPayload }


                    //setSelectedTipoGenerica(undefined);
                    //setComodin(prev => prev + 1);

                }
                else {
                    setTokenErrado(_payload['error']);
                    // pintar algo asociado al error
                }

            }
            else if (paramRol !== null && paramRol !== "") {

                //let paramQueryDecrypted = "";
                //paramQueryDecrypted = await genericaSistemaService.decryptString(idEmpresa, idioma, userName, paramQuery);
                //paramQueryDecrypted = paramQueryDecrypted + '';

                //let paramsQuery = paramQueryDecrypted.split("&");
                //let payloadParam = paramsQuery[1].split("=")[1];  //esto es por la integración con Aldea

                //payloadDecoded = decodeURI(paramQueryDecrypted);

                //let payloadStr = Buffer.from(payloadParam, 'base64') + "";//.toString('ascii');

                let _payload = { "hash": "aca77b7f1977ec1e7", "bodyContentPayload": { "item": { "idEmpresa": 1, "idioma": "ES", "selectedTipoGenerica": { "tg": "FMT_VSTA_FORMATO_PENDIENTE", "cti": "FMT_VSTA_FORMATO_PENDIENTE", "ctiTexto": "Formato Pendiente", "orden": 1, "version": "7CAFCA3A-66A2-4C0C-BBA5-04D32418BA1D", "filtroUts": { "documentotercero": "1103739087" }, "ctiTextoFiltroUts": "__" } } } };


                paramRol = paramRol.toUpperCase();

                console.log("payload, ", paramRol, idEmpresa);

                console.log("paramRol, ", paramRol, idEmpresa);
                if (paramRol == "ESTUDIANTE")
                    _payload = { "hash": "aca77b7f1977ec1e7", "bodyContentPayload": { "item": { "idEmpresa": idEmpresa, "idioma": "ES", "selectedTipoGenerica": { "tg": "FMT_VSTA_FORMATO_PENDIENTE_ESTUDIANTE", "cti": "FMT_VSTA_FORMATO_PENDIENTE_ESTUDIANTE", "ctiTexto": "Formato Pendiente", "orden": 1, "version": "7CAFCA3A-66A2-4C0C-BBA5-04D32418BA1D", "filtroUts": { "documentotercero": usernameDiligenciador !== undefined ? usernameDiligenciador.username : "132456789_!)(/:" }, "ctiTextoFiltroUts": "__" } } } };
                else if (paramRol === "DOCENTE")
                    _payload = { "hash": "aca77b7f1977ec1e7", "bodyContentPayload": { "item": { "idEmpresa": idEmpresa, "idioma": "ES", "selectedTipoGenerica": { "tg": "FMT_VSTA_FORMATO_PENDIENTE_DOCENTE", "cti": "FMT_VSTA_FORMATO_PENDIENTE_DOCENTE", "ctiTexto": "Formato Pendiente", "orden": 1, "version": "7CAFCA3A-66A2-4C0C-BBA5-04D32418BA1D", "filtroUts": { "documentotercero": usernameDiligenciador !== undefined ? usernameDiligenciador.username : "132456789_!)(/:" }, "ctiTextoFiltroUts": "__" } } } };
                else if (paramRol === "GRADUADO")
                    _payload = { "hash": "aca77b7f1977ec1e7", "bodyContentPayload": { "item": { "idEmpresa": idEmpresa, "idioma": "ES", "selectedTipoGenerica": { "tg": "FMT_VSTA_FORMATO_PENDIENTE_GRADUADO", "cti": "FMT_VSTA_FORMATO_PENDIENTE_GRADUADO", "ctiTexto": "Formato Pendiente", "orden": 1, "version": "7CAFCA3A-66A2-4C0C-BBA5-04D32418BA1D", "filtroUts": { "documentotercero": usernameDiligenciador !== undefined ? usernameDiligenciador.username : "132456789_!)(/:" }, "ctiTextoFiltroUts": "__" } } } };
                else if (paramRol === "DIRECTIVO")
                    _payload = { "hash": "aca77b7f1977ec1e7", "bodyContentPayload": { "item": { "idEmpresa": idEmpresa, "idioma": "ES", "selectedTipoGenerica": { "tg": "FMT_VSTA_FORMATO_PENDIENTE_DIRECTIVO", "cti": "FMT_VSTA_FORMATO_PENDIENTE_DIRECTIVO", "ctiTexto": "Formato Pendiente", "orden": 1, "version": "7CAFCA3A-66A2-4C0C-BBA5-04D32418BA1D", "filtroUts": { "documentotercero": usernameDiligenciador !== undefined ? usernameDiligenciador.username : "132456789_!)(/:" }, "ctiTextoFiltroUts": "__" } } } };
                else if (paramRol === "EMPLEADOR")
                    _payload = { "hash": "aca77b7f1977ec1e7", "bodyContentPayload": { "item": { "idEmpresa": idEmpresa, "idioma": "ES", "selectedTipoGenerica": { "tg": "FMT_VSTA_FORMATO_PENDIENTE_EMPLEADOR", "cti": "FMT_VSTA_FORMATO_PENDIENTE_EMPLEADOR", "ctiTexto": "Formato Pendiente", "orden": 1, "version": "7CAFCA3A-66A2-4C0C-BBA5-04D32418BA1D", "filtroUts": { "documentotercero": usernameDiligenciador !== undefined ? usernameDiligenciador.username : "132456789_!)(/:" }, "ctiTextoFiltroUts": "__" } } } };
                else if (paramRol === "PROVEEDOR")
                    _payload = { "hash": "aca77b7f1977ec1e7", "bodyContentPayload": { "item": { "idEmpresa": idEmpresa, "idioma": "ES", "selectedTipoGenerica": { "tg": "FMT_VSTA_FORMATO_PENDIENTE_PROVEEDOR", "cti": "FMT_VSTA_FORMATO_PENDIENTE_PROVEEDOR", "ctiTexto": "Formato Pendiente", "orden": 1, "version": "7CAFCA3A-66A2-4C0C-BBA5-04D32418BA1D", "filtroUts": { "documentotercero": usernameDiligenciador !== undefined ? usernameDiligenciador.username : "132456789_!)(/:" }, "ctiTextoFiltroUts": "__" } } } };
                else _payload = "";

                // Acá viene la particularidad de CECAR en el shortName del curso
                let newfiltroUts = _payload.bodyContentPayload.item.selectedTipoGenerica.filtroUts;

                /*
                let splitGrupo = newfiltroUts['codInternoCursoMoodle'].toString().split('_');
                let grupo = splitGrupo[0];  //se supone que es el primero

                if (splitGrupo.length === 0) {
                    grupo = "45326";
                }

                newfiltroUts['grupo'] = grupo;

                //delete newfiltroUts['codInternoCursoMoodle'];
                //console.log("newfiltroUts, ", newfiltroUts);

                
               
                let newTg = 'FMT_FORMATO-0'

                payload.bodyContentPayload.item.selectedTipoGenerica.tg = newTg

                payload.bodyContentPayload.item.selectedTipoGenerica.filtroUts = newfiltroUts;
                
                */


                //paypayload.bodyContentPayload.item.selectedTipoGenerica.filtroUts['codInternoMoodle'] = paypayload.bodyContentPayload.item.selectedTipoGenerica.filtroUts['codInternoMoodle'].split(',')[0];
                //paypayload.bodyContentPayload.item.selectedTipoGenerica.filtroUts['codMoodle']



                setPayLoad({ payloadDecoded: payloadDecoded, hash: _payload.hash, bodyContentPayload: _payload.bodyContentPayload });
                //payLoadRef.current = { payloadDecoded: payloadDecoded, hash: payload.hash, bodyContentPayload: payload.bodyContentPayload }


                //setSelectedTipoGenerica(undefined);
                //setComodin(prev => prev + 1);
            }

        }

    }

    const LoadEtiquetas = async () => {

        if (etiquetasModulo !== undefined && etiquetasModulo.length === 0) {

            await plantillaService.getEtiquetasModulo(codModulo, idEmpresa, idioma, userName).then(data => {
                setEtiquetasModulo(data);
            });

        }

    }

    useEffect(() => {

        if (userName !== undefined && userName !== "" && etiquetasModulo.length === 0) {
            LoadEtiquetas();
        }

    }, [etiquetasModulo])


    const codModulo = "DATATABLE_GENERICA";

    //const etiquetasModulo = props.etiquetasModulo;

    //const selectedTipoGenerica = props.selectedTipoGenerica;

    const [metadataGenericaSistema, setMetadataGenericaSistema] = useState([]);

    const [metadataGenericaSistemaTgOperaciones, setMetadataGenericaSistemaTgOperaciones] = useState([]);

    //const [modoEdicion, setModoEdicion] = useState(false);
    const [modoEdicion, setModoEdicion] = useState(true);

    const metadataGenericaSistemaForm = props.metadataGenericaSistemaForm;
    const genericaSistemaDialog = props.genericaSistemaDialog;

    const genericaSistemaDialogRef = useRef(null);
    const toast = useRef(null);

    const guidIntento = useRef(undefined);

    const _ = lodash;

    let emptyGenericaSistemaInit = {
        idEmpresa: idEmpresa, id: 0, ctiTexto: "", uts: []
    };

    const [emptyGenericaSistema, setEmptyGenericaSistema] = useState(emptyGenericaSistemaInit);


    const prevSelectedTipoGenericaRef = useRef(undefined);


    //const [comodin, setComodin] = useState(0);
    const [selectedTipoGenerica, setSelectedTipoGenerica] = useState(undefined);

    const [genericaSistema, setGenericaSistema] = useState(undefined);

    if (selectedTipoGenerica == undefined && payLoad !== null && payLoad.bodyContentPayload !== null) {
        //if (selectedTipoGenerica == undefined && payLoadRef.current !== null && payLoadRef.current.bodyContentPayload !== null) {
        //setSelectedTipoGenerica({ ...payLoadRef.current.bodyContentPayload.item.selectedTipoGenerica });
        setSelectedTipoGenerica({ ...payLoad.bodyContentPayload.item.selectedTipoGenerica });
    }
    else if (selectedTipoGenerica == undefined && props.selectedTipoGenerica !== undefined) {
        setSelectedTipoGenerica({ ...props.selectedTipoGenerica });
    }
    else if (props.selectedTipoGenerica !== undefined) {

        let newSelectedTipoGenerica = undefined;

        if (!_.isEqual(props.selectedTipoGenerica.filtroUts, selectedTipoGenerica.filtroUts)) {
            //else if (props.selectedTipoGenerica.filtroUts !== selectedTipoGenerica.filtroUts) {
            newSelectedTipoGenerica = { ...selectedTipoGenerica, version: props.selectedTipoGenerica.version, filtroUts: { ...props.selectedTipoGenerica.filtroUts }, variableRestriccionExterna: { ...props.selectedTipoGenerica.variableRestriccionExterna }, };
            setSelectedTipoGenerica(newSelectedTipoGenerica);
        }
        else if (props.selectedTipoGenerica.variableRestriccionExterna !== undefined
            && !_.isEqual(props.selectedTipoGenerica.variableRestriccionExterna, selectedTipoGenerica.variableRestriccionExterna)) {
            //else if (props.selectedTipoGenerica.filtroUts !== selectedTipoGenerica.filtroUts) {
            newSelectedTipoGenerica = { ...selectedTipoGenerica, version: props.selectedTipoGenerica.version, variableRestriccionExterna: { ...props.selectedTipoGenerica.variableRestriccionExterna }, };
            setSelectedTipoGenerica(newSelectedTipoGenerica);
        }
        else if (props.selectedTipoGenerica.version !== undefined && selectedTipoGenerica.version !== undefined && props.selectedTipoGenerica.version !== selectedTipoGenerica.version) {

            let newSelectedTipoGenerica2 = { ...selectedTipoGenerica, version: props.selectedTipoGenerica.version };
            setSelectedTipoGenerica(newSelectedTipoGenerica2);
        }

    }

    const [submitted, setSubmitted] = useState(false);

    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }

    useEffect(() => {

        if ((userName !== undefined && userName !== "" && selectedTipoGenerica !== undefined) && (
            1 === 1
            //selectedTipoGenerica.tipoOrganizacionContenido === undefined
            //|| selectedTipoGenerica.tipoOrganizacionContenido === "FORM_PENDIENTE_EXTERNAL"
        )
        ) {

            let prevselectedTipoGenerica = { ...selectedTipoGenerica }
            let isEmpty = _.isEqual({}, selectedTipoGenerica);

            if (prevSelectedTipoGenericaRef.current === undefined && selectedTipoGenerica !== undefined && !isEmpty) {
                LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
                prevselectedTipoGenerica["intentoMetadata"] = 0;
            }
            else if (prevSelectedTipoGenericaRef.current !== undefined && selectedTipoGenerica !== undefined && !isEmpty) {

                if (prevSelectedTipoGenericaRef.current.tg !== selectedTipoGenerica.tg) {
                    LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
                    prevselectedTipoGenerica["intentoMetadata"] = 0;
                }
                else if (metadataGenericaSistema.length === 0 && (prevSelectedTipoGenericaRef.current.intentoMetadata === undefined || prevSelectedTipoGenericaRef.current.intentoMetadata < 1)) {
                    LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
                    prevselectedTipoGenerica["intentoMetadata"] = prevSelectedTipoGenericaRef.current.intentoMetadata ? prevSelectedTipoGenericaRef.current.intentoMetadata + 1 : 1;
                }
                else {
                    //console.log("setLazyParams");
                    //setLazyParams({ ...lazyParams });
                }

            }

            prevSelectedTipoGenericaRef.current = prevselectedTipoGenerica;

        }

    }, [selectedTipoGenerica])

    const createHeaderGenerica = (objecto) => {

        let headers = "";

        //Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&')

        objecto.forEach(function (meta, indice, array) {
            if (indice > 0) {
                headers += ',';
            }
            else {
                headers += '{';
            }

            switch (meta.tipoDato) {
                case "string": headers += `"${meta.campo}":{ "value": "", "matchMode": "contains", "ref": null }`; break;
                default: headers += `"${meta.campo}":{ "value": "", "matchMode": "equals","ref": null }`; break;
            }

        });

        headers += '}';



        return (JSON.parse('' + headers + ''));
    }


    const LoadDatosGenerica = async (_tg, idEmpresa, idioma, userName) => {

        //lazyParamInit.filters = createHeaderGenerica([{ "campo": "" }]);

        if (selectedTipoGenerica.tg !== "") {

            if ((selectedTipoGenerica.operaciones === undefined || selectedTipoGenerica.operaciones.length === 0)) {

                //console.log("GetTipoGenericaSistemaByTg - Datatablegener, ", selectedTipoGenerica)
                genericaSistemaService.GetTipoGenericaSistemaByTg({ lazyEvent: JSON.stringify("") }, idEmpresa, idioma, userName, selectedTipoGenerica.tg).then(data => {

                    let newSelectedTipoGenerica = data.data;

                    if (selectedTipoGenerica.filtroUts !== undefined) {
                        newSelectedTipoGenerica.filtroUts = { ...selectedTipoGenerica.filtroUts };
                        newSelectedTipoGenerica.ctiTextoFiltroUts = selectedTipoGenerica.ctiTextoFiltroUts
                    }
                    if (selectedTipoGenerica.variableRestriccionExterna !== undefined) {
                        newSelectedTipoGenerica.variableRestriccionExterna = { ...selectedTipoGenerica.variableRestriccionExterna };
                    }
                    else {
                        newSelectedTipoGenerica.variableRestriccionExterna = {};
                    }

                    if (selectedTipoGenerica.operacionesCampos == undefined || !_.isEqual(selectedTipoGenerica.operacionesCampos, data.data.operacionesCampos)) {
                        newSelectedTipoGenerica.operacionesCampos = [...data.data.operacionesCampos];
                    }
                    if (selectedTipoGenerica.version !== undefined) {
                        newSelectedTipoGenerica.version = selectedTipoGenerica.version;
                    }

                    setSelectedTipoGenerica(newSelectedTipoGenerica);

                });
            }

            //else{}

            if (selectedTipoGenerica.operaciones !== undefined && metadataGenericaSistema.length === 0) {
                console.log("entro");
                //else if (metadataGenericaSistema.length === 0 && selectedTipoGenerica.operaciones !== undefined) {

                await genericaSistemaService.getMetadataGenericasConOperacionesDeTg(_tg, idEmpresa, idioma, userName).then(data => {


                    let columnaIdentificadorOculta = "tg";
                    let prefijo = '000000';
                    let TamSufijo = 4;
                    /*data = data.sort(function (a, b) {
                        let a1 = a.tg + '-' + (prefijo + a.orden).substring((prefijo + a.orden).length - TamSufijo) + '-' + a.campoOrigen + '-' + a.tipoDato;
                        let b1 = a.tg + '-' + (prefijo + b.orden).substring((prefijo + b.orden).length - TamSufijo) + '-' + b.campoOrigen + '-' + b.tipoDato;
                        return a1 > b1 ? 1 : a1 < b1 ? -1 : 0;
                    });*/

                    data = data.map(x => ({ ...x, formRef: null, columnRef: null, mensajeError: "" }));

                    let _metadataGenericaSistemaTgOperaciones = [...data];
                    //let _metadataGenericaSistemaTgOperaciones = data.map(x => x);
                    //setMetadataGenericaSistemaTgOperaciones(_metadataGenericaSistemaTgOperaciones);

                    data = data.filter(col => col.tg === _tg);

                    let metadataImprimible = data.filter(col => col.ctiConfigurado >= 0 && col.esImprimible > 0);

                    let dataForm = metadataImprimible;
                    let dataRef = data.map(x => ({ campo: x.campo, tipoDato: x.tipoDato, tg: x.tg, columnFiltroRef: null }));

                    if (dataRef.length > 0) {

                        //setEmptyGenericaSistema(crearNewEmptyGenerica(dataForm));



                        //lazyParamInit.filters = createHeaderGenerica(dataForm);
                        //lazyParamInit.filters = {};

                        //let newLazyParamInit = Object.assign({}, lazyParamInit);
                        //console.log("lazyParamInit, ", lazyParamInit);

                        //setMetadataGenericaSistema(data);

                        /*
                        setMetadataGenericaSistemaRef([...dataRef]);
                        setMetadataGenericaFormulario([...dataForm]);
                        setMetadataGenericaFormularioFactura([...dataForm]);

                        setSelectedTipoGenericaFormulario({ ...selectedTipoGenerica });
                        setSelectedTipoGenericaFormularioFactura({ ...selectedTipoGenerica });

                        */

                        if (selectedTipoGenerica.operaciones) {
                            let _canEditRow = selectedTipoGenerica.operaciones === undefined ? false : selectedTipoGenerica.operaciones.some(x => x.tg === selectedTipoGenerica.tg && x.tipoOperacion === "EDIT_ROW");
                            //setCanEditRow( (props.canEditRow | true) && selectedTipoGenerica.operaciones === undefined ? false : selectedTipoGenerica.operaciones.some(x => x.tg === selectedTipoGenerica.tg && x.tipoOperacion === "EDIT_ROW"));
                        }

                        setMetadataGenericaSistema(_metadataGenericaSistemaTgOperaciones.filter(x => x.tg === _tg && x.ctiConfigurado >= 0 && (x.esImprimible > 0 || x.esSoloLectura > 0)));

                        setMetadataGenericaSistemaTgOperaciones(_metadataGenericaSistemaTgOperaciones);

                        let newGenerica = crearNewEmptyGenerica(dataForm);
                        setGenericaSistema(newGenerica);

                        //setLazyParams({ ...newLazyParamInit });
                        //lazyParamsInitSelected.current = newLazyParamInit;

                    }

                });





            }
        }

    }

    const crearNewEmptyGenerica = (metadata) => {

        let item = {}

        item['id'] = 0;
        item['idEmpresa'] = idEmpresa;
        item['idioma'] = "ES";
        item['tg'] = metadata.length > 0 ? metadata[0].tg : "";

        item['uts'] = {};

        metadata.forEach(x => {
            if (x.campo === "tg")
                item[`${x.campo}`] = x.tg;

            else {

                let newVal = "";
                if (x.tipoDato === "date")
                    newVal = 0;
                else if (x.tipoDato === "int") newVal = 0;
                else if (x.tipoDato === "double") newVal = 0.0;
                else if (x.tipoDato === "money") newVal = 0;
                else if (x.tipoDato === "boolean") newVal = false;
                else newVal = "";

                if (selectedTipoGenerica.filtroUts !== undefined) {

                    if (selectedTipoGenerica.filtroUts[x.campo] !== undefined && selectedTipoGenerica.filtroUts[x.campo] !== "") {
                        newVal = selectedTipoGenerica.filtroUts[x.campo];
                        item['uts'][`${x.campo}`] = newVal
                    }


                    //console.log("newVal,", x.campo,newVal);
                    //console.log("selectedTipoGenerica,", selectedTipoGenerica);
                }



                //item['uts'] = { ...item['uts'], [`${x.campo}`]: newVal }

            }
        });

        return item;

    }

    const genericaSistemaDialogFooter = (
        <>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" // onClick={props.onHideForm} 
            />
            <Button label="Guardar" icon="pi pi-check" className="p-button-text" // onClick={savegenericaSistema} 
            />
        </>
    );

    const onClickEditarFormularioFactura = async () => {

    }

    const FormularioFacturaHeader = () => {

        if (!modoEdicion) {

            return (<><span>asdfasfsf</span></>);

        }
        else {
            return (<><span>asdfasfsf</span></>);
        }
    }

    const onChangeDataInterno = (e, metadataRef) => {
    }

    const onSaveSuccessfulFormulario = (_genericaSistema, idOriginal, genericasSistemaAffect) => {

    }

    const onDataLoaded = (_genericasSistema) => {

        console.log("_genericasSistema, ", _genericasSistema);
        if (_genericasSistema.length === 0 && (!selectedTipoGenerica.tg.includes("FMT_VSTA_FORMATO_PENDIENTE"))) {
            setTokenErrado("No hay se encontraron eventos pendientes para registro");
        }

    }

    const FormLogin = () => {

        if (idEmpresa !== 2) {

            return (<div className="w-full md:w-5 flex flex-column align-items-center justify-content-center gap-3 py-5">
                <div className="flex flex-wrap justify-content-center align-items-center gap-2">
                    <label className="w-full">Credenciales de Acceso </label>
                </div>
                <div className="w-full">

                    <label className="w-full">Usuario</label>
                    <InputText id="username" type="text" onChange={(e) => onInputChangeLogin(e, 'userName')} className="w-full" />
                </div>
                <div className="w-full">
                    <label className="w-6rem">Clave</label>
                    <InputText id="password" type="password" onChange={(e) => onInputChangeLogin(e, 'password')} className="w-full" />
                </div>
                <Button label="Ingresar" onClick={clickLogin} icon="pi pi-user" className="w-fullmx-auto"></Button>
            </div>)

        }
        else return (<></>);

    }

    const renderUserDetected = () => {

        const userDetails = authStorage.GetCurrentUserLocal();

        let { userName, sessionGUID } = userDetails;
        let labelBoton = "Seguir como " + userName;

        if (userName !== "" && userName !== "visit" && userName !== "guest" && idEmpresa !== 2) {

            return (<>

                <div className="w-full md:w-5 flex flex-column align-items-center justify-content-center gap-3 py-5">
                    <div className="flex flex-wrap justify-content-center align-items-center gap-2">
                        <label className="w-full">Usuario detectado</label>
                    </div>


                    <div className="w-full md:w-5 flex align-items-center justify-content-center py-5">
                        <Button label={labelBoton} onClick={clickAsDetectedUser} icon="pi pi-user-plus" severity="success" className=""></Button>
                    </div>

                </div>

                <div className="w-full md:w-2">
                    <Divider layout="vertical" className="hidden md:flex">

                    </Divider>
                    <Divider layout="horizontal" className="flex md:hidden" align="center">

                    </Divider>
                </div>
            </>);

        }
        else {
            return (<></>);
        }

    }

    const onInputChangeLogin = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _formLogin = { ...formLogin };
        _formLogin[`${name}`] = val;
        setFormLogin(_formLogin);
    }

    const clickLogin = async (e) => {

        console.log("clickLogin, ");
        //e.preventDefault();
        try {

            if (formLogin.userName !== undefined && formLogin.password !== undefined && formLogin.userName !== "" && formLogin.password !== "") {

                let response = await authController.loginUser(formLogin) //loginUser action makes the request and handles all the neccessary state changes
                //console.log(props.nextProps);
                if (response.sessionGUID !== null && response.sessionGUID !== "") {

                    userName = response.userName;
                    sessionGUID = response.sessionGUID;

                    setUsernameDiligenciador(response);

                    let newSelectedTipoGenerica = { ...selectedTipoGenerica }
                    newSelectedTipoGenerica.filtroUts['usernametercero'] = userName;
                    delete newSelectedTipoGenerica.filtroUts.documentoInvitado;

                    setSelectedTipoGenerica(newSelectedTipoGenerica);

                }
                //window.location.href = process.env.NEXT_PUBLIC_FOLDER_APP + "/home";
                //window.location.href ='/generica2'; //navigate to dashboard on success
                else {
                    setIntentoErrado((prev) => prev + 1);
                }

            }
            else {

            }
        } catch (error) {
            console.log(error)
        }

        setVecesBotonPresionado(prev => prev + 1);

    }

    const onInputChangeAsVisit = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _formAsVisit = { ...formAsVisit };
        _formAsVisit[`${name}`] = val;
        setFormAsVisit(_formAsVisit);
    }

    const clickAsVisit = async (e) => {

        console.log("clickAsVisit,");

        //e.preventDefault();
        try {

            if (formAsVisit.documentoInvitado !== undefined && formAsVisit.documentoInvitado !== "") {

                //console.log(props.nextProps);

                let response = await authController.loginVisitUser(formAsVisit) //loginUser action makes the request and handles all the neccessary state changes

                setUsernameDiligenciador(userName);

                let newSelectedTipoGenerica = { ...selectedTipoGenerica }
                newSelectedTipoGenerica.filtroUts['usernametercero'] = userName;

                if (selectedTipoGenerica.tg === "FMT_VSTA_FORMATO_PENDIENTE_EMPLEADOR" ||
                    (idEmpresa === 2 && selectedTipoGenerica.tg === "FMT_VSTA_FORMATO_PENDIENTE_DIRECTIVO")
                ) {
                    newSelectedTipoGenerica.filtroUts['documentotercero'] = formAsVisit.documentoInvitado;
                }
                else if (selectedTipoGenerica.tg.includes("FMT_VSTA_FORMATO_PENDIENTE_") && selectedTipoGenerica.tg !== "FMT_VSTA_FORMATO_PENDIENTE_EMPLEADOR") {
                    newSelectedTipoGenerica.filtroUts['documentotercero'] = formAsVisit.documentoInvitado;
                    //newSelectedTipoGenerica.filtroUts['usernametercero'] = formAsVisit.documentoInvitado;
                }
                else {
                    newSelectedTipoGenerica.filtroUts['documentoInvitado'] = formAsVisit.documentoInvitado;
                }


                setSelectedTipoGenerica(newSelectedTipoGenerica);

                //window.location.href = process.env.NEXT_PUBLIC_FOLDER_APP + "/home";
                //window.location.href ='/generica2'; //navigate to dashboard on success
            }

        } catch (error) {
            console.log(error)
        }

        setVecesBotonPresionado(prev => prev + 1);

    }

    const clickAsDetectedUser = async (e) => {

        //e.preventDefault();
        try {

            const userDetails = authStorage.GetCurrentUserLocal();

            if (userDetails.userName !== undefined) {

                //console.log(props.nextProps);

                let response = await authController.loginUserDetected(userDetails) //loginUser action makes the request and handles all the neccessary state changes

                setUsernameDiligenciador(userDetails);

                let newSelectedTipoGenerica = { ...selectedTipoGenerica }
                newSelectedTipoGenerica.filtroUts['usernametercero'] = userDetails.userName;
                delete newSelectedTipoGenerica.filtroUts.documentoInvitado;
                //newSelectedTipoGenerica.filtroUts['documentoInvitado'] = formAsVisit.documentoInvitado;

                setSelectedTipoGenerica(newSelectedTipoGenerica);

                //window.location.href = process.env.NEXT_PUBLIC_FOLDER_APP + "/home";
                //window.location.href ='/generica2'; //navigate to dashboard on success
            }

        } catch (error) {
            console.log(error)
        }

        setVecesBotonPresionado(prev => prev + 1);

    }

    console.log("payLoadRef.current, ", idEmpresa, usernameDiligenciador, etiquetasModulo.length, selectedTipoGenerica, payLoad)

    //if (!genericaSistemaDialog || etiquetasModulo.length === 0)
    if (tokenErrado) {
        return (<>
            <Dialog visible={true} style={{ width: '90vw' }} closable={false} >
                {tokenErrado}
            </Dialog>
        </>)
    }
    else if (idEmpresa <= 0 || userName === undefined || userName === ""
        //|| genericaSistemaDialog === false 
        || etiquetasModulo.length === 0
        || selectedTipoGenerica === undefined || selectedTipoGenerica.operaciones === undefined
        //|| (selectedTipoGenerica.tipoOrganizacionContenido !== "FORM_PENDIENTE_EXTERNAL")
        //|| metadataGenericaSistemaTgOperaciones.length === 0        
        //|| genericaSistema === undefined

        //|| genericasSistema_FORMULARIO_STRUCT_CONSOLIDADO === null || genericasSistema_FORMULARIO_STRUCT_NOTAPADRE === null || genericasSistema_FORMULARIO_STRUCT_DETALLE === null

    )

        return (<></>);

    else if (idEmpresa <= 0 || userName === undefined || userName === ""
        //|| genericaSistemaDialog === false 
        || etiquetasModulo.length === 0
        || selectedTipoGenerica === undefined || selectedTipoGenerica.operaciones === undefined
        //|| (selectedTipoGenerica.tipoOrganizacionContenido !== "FORM_PENDIENTE_EXTERNAL")
        || metadataGenericaSistemaTgOperaciones.length === 0

        //|| genericasSistema_FORMULARIO_STRUCT_CONSOLIDADO === null || genericasSistema_FORMULARIO_STRUCT_NOTAPADRE === null || genericasSistema_FORMULARIO_STRUCT_DETALLE === null

    ) {

        return (<></>);
    }

    else if (usernameDiligenciador === undefined

        //|| genericasSistema_FORMULARIO_STRUCT_CONSOLIDADO === null || genericasSistema_FORMULARIO_STRUCT_NOTAPADRE === null || genericasSistema_FORMULARIO_STRUCT_DETALLE === null

    ) {

        //console.log("formLogin, ", formLogin);

        console.log("dataTableGenericaRef, ", dataTableGenericaRef.current);


        return (<>
            <div className="card">

                <div className='tablaOculta'>
                    <DataTableGenerica
                        ref={dataTableGenericaRef} //genericaSistemaDialog={genericaSistemaDialogFormularioFactura} 
                        genericaSistemaDialog={true}
                        genericaSistema={genericaSistema}
                        //metadataGenericaSistemaForm={metadataGenericaFormularioFactura}
                        etiquetasModulo={etiquetasModulo}
                        selectedTipoGenerica={selectedTipoGenerica}
                        //onHideForm={hideDialog} 
                        onSaveSuccessful={onSaveSuccessfulFormulario}
                        onDataLoaded={onDataLoaded}
                    ></DataTableGenerica>
                </div>

                <Dialog visible={dialogTextVisible} style={{ width: '90vw' }} closable={false} >

                    <div className="flex flex-column md:flex-row">

                        {renderUserDetected()}

                        {FormLogin()}

                        <div className="w-full md:w-2">
                            <Divider layout="vertical" className="hidden md:flex">

                            </Divider>
                            <Divider layout="horizontal" className="flex md:hidden" align="center">

                            </Divider>
                        </div>


                        <div className="w-full md:w-5 flex flex-column align-items-center justify-content-center gap-3 py-5 ">
                            <div className="flex flex-wrap justify-content-center align-items-center gap-2 top-0" >
                                <label className="w-full">Como Invitado</label>
                            </div>
                            <div className="w-full">
                                <label className="w-full">Identificación</label>
                                <InputText id="documentoInvitado" type="text" onChange={(e) => onInputChangeAsVisit(e, 'documentoInvitado')} className="w-full" />

                            </div>
                            <div className="w-full">
                                <Button label="Seguir" onClick={clickAsVisit} icon="pi pi-user" className="w-full" ></Button>
                            </div>
                        </div>

                    </div>


                </Dialog >
            </div>
        </>);
    }

    else {
        return (

                    <DataTableGenerica
                        ref={dataTableGenericaRef} //genericaSistemaDialog={genericaSistemaDialogFormularioFactura} 
                        genericaSistemaDialog={true}
                        genericaSistema={genericaSistema}
                        //metadataGenericaSistemaForm={metadataGenericaFormularioFactura}
                        etiquetasModulo={etiquetasModulo}
                        selectedTipoGenerica={selectedTipoGenerica}
                        //onHideForm={hideDialog} 
                        onSaveSuccessful={onSaveSuccessfulFormulario}
                    ></DataTableGenerica>

 
        );
    }

}

/*const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};
 
export default React.memo(BlocksLogin, comparisonFn);*/

//export default BlocksPublicURLShared;
export default connect(null)(BlocksPublicURLShared);
